import React, { useEffect, useState } from 'react';
import './homepage.css';
import './header.css';
import "./modal.css";
import { Modal, Box, Button } from '@mui/material';
import { CircleCheckBig, CircleX } from 'lucide-react';
import PrinterSetup from '../PrinterSetup';

const varData = [
  { id: "37", variable: "brandName" },
  { id: "36", variable: "categoryName" },
  { id: "28", variable: "centerstone_pcs_wt" },
  { id: "27", variable: "centerstone_shape_quality_color" },
  { id: "43", variable: "certlogo" },
  { id: "26", variable: "certno" },
  { id: "29", variable: "certtype" },
  { id: "35", variable: "collectionname" },
  { id: "32", variable: "csactualctw" },
  { id: "34", variable: "csactualpcsused" },
  { id: "21", variable: "cspcs1" },
  { id: "22", variable: "cspcs2" },
  { id: "23", variable: "cspcs3" },
  { id: "18", variable: "csquality1" },
  { id: "19", variable: "csquality2" },
  { id: "20", variable: "csquality3" },
  { id: "15", variable: "cswt1" },
  { id: "16", variable: "cswt2" },
  { id: "17", variable: "cswt3" },
  { id: "42", variable: "customercode" },
  { id: "1", variable: "designno" },
  { id: "31", variable: "diaactualctw" },
  { id: "33", variable: "diaactualpcsused" },
  { id: "39", variable: "Diamond_actualctw_without_centerstone" },
  { id: "40", variable: "Diamond_pcs_without_centerstone" },
  { id: "12", variable: "diapcs1" },
  { id: "13", variable: "diapcs2" },
  { id: "14", variable: "diapcs3" },
  { id: "6", variable: "diaquality1" },
  { id: "7", variable: "diaquality2" },
  { id: "8", variable: "diaquality3" },
  { id: "9", variable: "diawt1" },
  { id: "10", variable: "diawt2" },
  { id: "11", variable: "diawt3" },
  { id: "30", variable: "fgmarkup" },
  { id: "4", variable: "grosswt" },
  { id: "24", variable: "HUID" },
  { id: "3", variable: "metaltype" },
  { id: "5", variable: "netwt" },
  { id: "41", variable: "ntwd" },
  { id: "25", variable: "refid" },
  { id: "2", variable: "serialjobno" },
  { id: "38", variable: "subcategoryname" }
];
const defaultSelectedIds = [1, 2, 3, 4, 5, 24, 42];
const HomePage = () => {
  const [varList, setVarList] = useState([]);
  const [selectedVariables, setSelectedVariables] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [disableFields, setDisableFields] = useState(false);
  const [disableFields2, setDisableFields2] = useState(false);
  const [fileReplacedContent, setFileReplacedContent] = useState(null);
  const [userJobno, setUserJobno] = useState('');
  const [resultArr, setResultArr] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [previewImage, setPreviewImage] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleCheckboxChange = (e, variable) => {

    let arr = varList?.map((e) => {
      if (e?.id === variable?.id) {
        let obj = { ...e };
        if (!obj.isCheckBox) {
          obj.isCheckBox = true;
          setSelectedVariables((prev) => [...prev, obj])
        } else {
          obj.isCheckBox = false;
          setSelectedVariables((prev) => prev?.filter((a) => a?.id !== variable?.id))
        }
        return obj;
      } else {
        return e;
      }
    })
    setVarList(arr);
  };

  const handleClearAll = () => {
    setSelectedVariables([])
    setVarList((prev) => prev?.map((e) => ({ ...e, isCheckBox: false })))
    setDisableFields(false);
    setDisableFields2(false);
    setFileReplacedContent(null);
    setTimeout(() => {
      setDisableFields(false);
      setDisableFields2(false);
      setFileReplacedContent(null);
    }, 10)
  };

  const handleValueChange = (a, variable) => {
    setErrorMsg('');
    setSelectedVariables((prev) =>
      prev.map((el) =>
        el.id === variable.id
          ? { ...el, enteredValue: a.target.value }
          : el
      )
    );
  };

  function replaceVariablesInZPL(zpl, selectedVariables) {
    let updated = zpl;

    selectedVariables.forEach((item) => {
      let placeholder = `{{${item.variable}}}`;   // ex: {{grosswt}}
      let val = item.enteredValue || "";

      updated = updated.replaceAll(placeholder, val);
    });

    return updated;
  }


  const handleSubmit = () => {
    let resultArr = [];
    let someIsEmpty = selectedVariables?.some((e) => e?.enteredValue === '');
    if (someIsEmpty) {
      setErrorMsg('Please fill in all selected variables.');
    }
    else {
      setErrorMsg('');
      selectedVariables?.forEach((a) => {
        let obj = { ...a };
        obj.userEnteredValue = convertIfNumber(obj?.enteredValue);
        if (obj?.id === 2) {
          setUserJobno(obj?.userEnteredValue);
        }
        resultArr.push(obj);
        setDisableFields(true);
      })
      setResultArr(resultArr);
    }
  }

  function convertIfNumber(value) {
    if (!isNaN(value) && value.trim() !== "") {
      return Number(value);
    } else {
      return value;
    }
  }
  useEffect(() => {
    let arr = (varData || [])?.sort((a, b) => a?.variable?.localeCompare(b?.variable))?.map((e) => ({ ...e, isCheckBox: defaultSelectedIds?.includes(e?.id), enteredValue: '' }));
    setVarList(arr);
    const initialSelectedVariables = arr?.filter((item) => defaultSelectedIds.includes(item.id));
    setSelectedVariables(initialSelectedVariables);
  }, []);

  const handlePrint = () => {
    window.print();
  }

  const handlePreviewImage = async () => {
    if (!fileReplacedContent) {
      alert("Upload ZPL file first");
      return;
    }

    // Replace {{variables}} with actual values
    const finalZPL = replaceVariablesInZPL(fileReplacedContent, selectedVariables);
    console.log("FINAL ZPL:", finalZPL);

    try {
      const res = await fetch(
        "https://api.labelary.com/v1/printers/8dpmm/labels/6.3x2.3/0/",
        {
          method: "POST",
          headers: {
            "Accept": "image/png",
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: finalZPL
        }
      );

      if (!res.ok) {
        console.error("API Error", await res.text());
        alert("API failed");
        return;
      }

      const blob = await res.blob();
      const imgURL = URL.createObjectURL(blob);
      setPreviewImage(imgURL);
      setOpen(true);

    } catch (error) {
      console.error(error);
      alert("Preview failed");
    }
  };

  return (<>
    <div className='bgcolor_home'>
      <div className='header_rfid'>
        <div className='head_div2'></div>
        <div className='head_div1'>RFID PRINTING MODULE</div>
        <div className='head_div3' title='help'>i</div>
      </div>
      <div className="homepage">
        <div className="addValue">
          {<>
            {<div className='w_100'>
              <div style={{ display: 'flex', alignItems: 'center' }}>
              </div>
              <div className=''>
                <div className='tableContainer'>
                  <PrinterSetup />
                  <table style={{ width: '85%' }} className='tableBorder_rfid'>
                    <thead className='stickyheaderrfid'>
                      <tr>
                        <th style={{ width: '10%', fontSize: '17px', height: '40px', fontWeight: 400 }} align='center'>ID</th>
                        <th style={{ width: '50%', fontSize: '17px', height: '40px', fontWeight: 400 }} align='center'>Variable</th>
                        <th style={{ width: '40%', fontSize: '17px', height: '40px', fontWeight: 400 }} align='center'>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        selectedVariables?.map((e, i) => {
                          return (
                            <tr key={i}>
                              <td align='center' style={{ fontSize: '15px' }}>{i + 1}</td>
                              <td align='start' style={{ fontSize: '15px' }}>{e?.variable}</td>
                              <td align='center' ><input type="text" style={{ width: '75%' }} className='inputFieldDyn' disabled={disableFields} value={e?.enteredValue} onChange={(a) => handleValueChange(a, e)} /></td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>
                <div style={{ height: '40px', color: 'red', fontSize: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{errorMsg}</div>
              </div>

              <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'center', margin: '5px 5px' }}><Button disabled={disableFields} variant='contained' sx={{ mx: 1 }} size='small' color='success' onClick={() => handleSubmit()}>Submit</Button></div>
                {(disableFields) && <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '5px' }} title='Preview Of Selected Values'><Button variant='contained' size='small' sx={{ mx: 1, backgroundColor: '#ff9800' }}
                  onClick={handlePreviewImage}
                >PREVIEW</Button></div>}
                {(disableFields) && <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '5px' }} title='Print'><Button variant='contained' size='small' sx={{ mx: 1, backgroundColor: '#ff9800' }} onClick={() => handlePrint()}>PRINT</Button></div>}
                {disableFields && (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      accept="*/*"
                      style={{ display: 'none' }}
                      id="file-upload"
                      type="file"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (!file) return;
                        setUploadedFile(file);
                        setUploadedFileName(file.name);
                        const reader = new FileReader();
                        reader.onload = (ev) => {
                          let fileContent = ev.target.result;
                          setFileReplacedContent(fileContent);
                        };
                        reader.readAsText(file);
                      }}
                    />

                    <label htmlFor="file-upload" style={{ marginBottom: '5px' }}>
                      <Button
                        variant="contained"
                        color="secondary"
                        disabled={disableFields2}
                        size="small"
                        sx={{ mx: 1 }}
                        component="span"
                        className="muBtn"
                      >
                        Upload File
                      </Button>
                    </label>

                    {uploadedFile && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{
                          fontSize: "14px", marginRight: "8px",
                          display: 'flex',
                          backgroundColor: 'rgb(0 128 0 / 18%)',
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: '7px 20px',
                          color: 'green',
                          borderRadius: '5px',
                          gap: '20px'
                        }}>
                          Uploded File :
                          {uploadedFileName}
                          <CircleCheckBig style={{ height: '15px' }} />
                        </span>
                        <span
                          onClick={() => {
                            setUploadedFile(null);
                            setUploadedFileName('');
                            setFileReplacedContent(null);
                            document.getElementById("file-upload").value = null;
                          }}
                          style={{
                            cursor: "pointer",
                            fontWeight: "bold",
                            color: "red",
                            fontSize: "30px",
                          }}
                        >
                          <CircleX style={{ color: 'red' }} />
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>}
          </>}
        </div>
        <div className="homepageContainer">
          <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
            <h4 style={{ width: '15%', color: '#4D5257', display: 'flex', justifyContent: 'center', cursor: 'pointer' }} title='Default Selected'>{selectedVariables?.length} / {varList?.length}</h4>
            <h2 className="title" style={{ width: '80%' }}>Pick Your Variables</h2>
            <div style={{ width: '5%' }}>&nbsp;</div>
          </div>
          <div className="varBox">
            {varList?.map((e) => {
              return (
                <div key={e?.id} className="flexbox">
                  <input type="checkbox" id={`${e?.id}`} style={{ cursor: 'pointer' }} disabled={disableFields} checked={e?.isCheckBox} onChange={(el) => handleCheckboxChange(el, e)} />
                  <label htmlFor={`${e?.id}`} className="varLabel">
                    {e?.variable}
                  </label>
                </div>
              );
            })}
          </div>
          <div style={{ paddingBottom: '10px', paddingRight: '20px', display: 'flex', justifyContent: 'flex-end' }}>
            <Button size='small' variant='contained' color='error' onClick={() => handleClearAll()}>Clear All</Button>
          </div>
        </div>
      </div>
    </div>
    <Modal
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={open}
      onClose={handleClose}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 1200,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          paddingBottom: '10px',
          paddingTop: '10px',
          borderRadius: '8px'
        }}>
        <h3 className='modal_title'>
          Sample Preview Of Created Tag
        </h3>
        {previewImage && (
          <img
            src={previewImage}
            alt="ZPL Preview"
            style={{ width: "100%", border: "1px solid #ccc", marginTop: "10px" }}
          />
        )}

        {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div className='createdTag'>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <div style={{ padding: '5px' }}>
                {
                  resultArr?.slice(0, 5)?.map((e, i) => {
                    return (
                      <div key={i}>
                        <div className='tagfs'>{e?.userEnteredValue}</div>
                      </div>
                    )
                  })
                }
              </div>
              <div style={{ padding: '5px' }}>
                {
                  resultArr?.slice(5)?.map((e, i) => {
                    return (
                      <div key={i}>
                        <div className='tagfs'>{e?.userEnteredValue}</div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
            <div className='tag_qrcode'>
              <QRCode value={userJobno} size={60} />
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div className='disclamer' style={{ color: 'red', fontWeight: 'bolder' }}>
            Actual Design may be different as per your zpl file.
          </div>
        </div> */}
        <div style={{ display: 'flex', justifyContent: 'center' }}><Button sx={{ mt: 2 }} variant='contained' size='small' onClick={() => setOpen(false)}>Close</Button></div>
      </Box>
    </Modal>
  </>
  );
};

export default HomePage;